import React, { createContext, useContext, useState, useCallback } from "react";

const BookingContext = createContext({ open: () => {}, close: () => {}, isOpen: false });

export function BookingProvider({ children }) {
    const [isOpen, setIsOpen] = useState(false);
    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);
    return (
        <BookingContext.Provider value={{ isOpen, open, close }}>
            {children}
        </BookingContext.Provider>
    );
}

export const useBooking = () => useContext(BookingContext);
